export const currentAdvisorInvoicesReducer = (currentAdvisorInvoices = [], action) => {
    switch (action.type) {
        case 'set_current_advisor_invoices':
            return action.payload;
        default:
            return currentAdvisorInvoices;
    }
}